(function() {
    'use strict';

    angular
        .module('app.permisos')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/permisos/:id',
                config: {
                    templateUrl: 'app/permisos/permisos.html',
                    controller: 'Permisos',
                    controllerAs: 'vm',
                    title: 'Permisos',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-login"></i> login'
                    }
                }
            }
        ];
    }
})();
